"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Button = function (_a) {
    var _b = _a.float, float = _b === void 0 ? true : _b, props = __rest(_a, ["float"]);
    var styles = __assign({ minWidth: '5em' }, props.style);
    var css = "text-capitalize btn " + props.className;
    var button = (jsx_runtime_1.jsx("button", __assign({}, props, { style: styles, className: css }, { children: props.children }), void 0));
    return (jsx_runtime_1.jsx("div", __assign({ className: "d-flex " + (float ? 'justify-content-end' : '') }, { children: button }), void 0));
};
exports.Button = Button;
//# sourceMappingURL=index.js.map